import React, { Component } from "react";
import * as reactDeviceDetect from "react-device-detect";
// import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
// import "react-tabs/style/react-tabs.css";
import {
  Button,
  FormGroup,
  // ControlLabel,
  FormControl,
  Form,
} from "react-bootstrap";
import "../../routes/app";
import { fire, auth } from "../../firebase/index";
import * as firebase from "firebase";

import { updateEmail } from "./ResetEmailHelper";

//CSS
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "../../assets/css/account-management.css";

import LocalizedStrings from "react-localization";
import AlertError from "material-ui/svg-icons/alert/error";

import verifyCheck from "../../assets/img/verifyCheck.png";

import { SUPER_ADMIN_DETAILS, customLog } from "../../variables/Variables";
import { TREE_NODE_SECONDARY_LABEL } from "@blueprintjs/core/lib/esm/common/classes";
import { once, update } from "lodash";

const randomString = require("randomstring");
// import { TouchableHighlightBase } from "react-native";

//import localization
//Localization codes

const DB = fire.database();

const BLANK_ERR_MSG = 1;
const INCORRECT_ERR_MSG = 2;
const SUCCESS_MSG = 0;

const EMAIL_INCORRECT_MATCH_ERR = 1;
const EMAILS_BLANK_ERR = 2;
const EMAIL_SAME_ERR = 3;
const EMAIL_SUCCESS = 0;

const EXISTING_ACC_ERR = 4;
const AUTHENTICATE_ACC_ERR = 5;
const EMAIL_ALREADY_EXISTS = 6;

const CODE_DOES_NOT_MATCH = 7;
const SESSION_TIMEOUT = 8;
const CODE_SUCCESS = 9;

let localizationStrings = new LocalizedStrings({
  en: {
    newEmailTitle: "New Email",
    currentEmailTitle: "Current Email",
    confirmNewEmailTitle: "Confirm New Email",
    confirmButton: "Confirm",
    clearAllButton: "Send verification code",
    confirmEmailAlert: "Emails do not match! Please try again.",
    enterEmailsAlert: "Please enter your New Email and confirm New Email",
    emailAlrExists:
      "The email you entered already belongs to an existing account",
    verifyWrongCodeError: "Code does not match",
    verifyCodeTimeOut: "Session expired. Please try again.",
    updateEmailTitle: "Step 1 : Confirm Your Email",
    verifyPWTitle: "Step 3 : Verify Account Password",
    verifyBtn: "Verify",
    verifyPasswordBlank: "Field cannot be blank",
    verifyPasswordInput: "Please enter your Password",
    verifyPasswordErr: "Incorrect Password. Please try again.",
    blankEmailErrorDescription:
      "Please enter your new email and confirm new email",
    emailMatchErrorDescription: "Emails do not match! Please try again.",
    emailMatchCurrentErrorDescription:
      "Your new email should not match your current email",
    exisitingAccountErrDescription: "Email is already taken",
    reAuthenticateErrDescription:
      "Session timeout. Please verify your account again",
    verifyNewEmailTitle: "Step 2 : Verify New Email",
    verifyNewEmailDescription:
      "A verification code has been sent to your new email. The code is valid for 5 minutes.",
    verifyEmailCodePlaceHolder: "Enter your code",
  },
  ja: {
    newEmailTitle: "新しいメール",
    currentEmailTitle: "現在のメール",
    confirmNewEmailTitle: "新しいメールを確認",
    confirmButton: "確認",
    clearAllButton: "確認コードを送信",
    confirmEmailAlert: "メールが一致しません！もう一度お試しください。",
    enterEmailsAlert: "新しいメールと新しいメールの確認を入力してください",
    emailAlrExists: "入力したメールは既存のアカウントに属しています",
    verifyWrongCodeError: "コードが一致しません",
    verifyCodeTimeOut: "セッションが期限切れです。もう一度お試しください。",
    updateEmailTitle: "ステップ 1: メールを確認",
    verifyPWTitle: "ステップ 3: アカウントのパスワードを確認",
    verifyBtn: "確認",
    verifyPasswordBlank: "フィールドは空白にできません",
    verifyPasswordInput: "パスワードを入力してください",
    verifyPasswordErr: "パスワードが間違っています。もう一度お試しください。",
    blankEmailErrorDescription:
      "新しいメールを入力し、新しいメールを確認してください",
    emailMatchErrorDescription:
      "メールが一致しません！もう一度お試しください。",
    emailMatchCurrentErrorDescription:
      "新しいメールは現在のメールと一致してはいけません",
    exisitingAccountErrDescription: "メールはすでに取得されています",
    reAuthenticateErrDescription:
      "セッションのタイムアウト。もう一度アカウントを確認してください",
    verifyNewEmailTitle: "ステップ 2: 新しいメールを確認",
    verifyNewEmailDescription:
      "新しいメールに確認コードが送信されました。コードは5分間有効です。",
    verifyEmailCodePlaceHolder: "コードを入力してください",
  },
  es: {
    newEmailTitle: "Nuevo Correo Electrónico",
    currentEmailTitle: "Correo Electrónico Actual",
    confirmNewEmailTitle: "Confirmar Nuevo Correo Electrónico",
    confirmButton: "Confirmar",
    clearAllButton: "Enviar código de verificación",
    confirmEmailAlert:
      "¡Los correos electrónicos no coinciden! Por favor, inténtalo de nuevo.",
    enterEmailsAlert:
      "Por favor, ingresa tu Nuevo Correo Electrónico y confirma el Nuevo Correo Electrónico",
    emailAlrExists:
      "El correo electrónico que ingresaste ya pertenece a una cuenta existente",
    verifyWrongCodeError: "El código no coincide",
    verifyCodeTimeOut: "La sesión ha expirado. Por favor, inténtalo de nuevo.",
    updateEmailTitle: "Paso 1: Confirma Tu Correo Electrónico",
    verifyPWTitle: "Paso 3: Verifica la Contraseña de la Cuenta",
    verifyBtn: "Verificar",
    verifyPasswordBlank: "El campo no puede estar en blanco",
    verifyPasswordInput: "Por favor, ingresa tu Contraseña",
    verifyPasswordErr: "Contraseña incorrecta. Por favor, inténtalo de nuevo.",
    blankEmailErrorDescription:
      "Por favor, ingresa tu nuevo correo electrónico y confirma el nuevo correo electrónico",
    emailMatchErrorDescription:
      "¡Los correos electrónicos no coinciden! Por favor, inténtalo de nuevo.",
    emailMatchCurrentErrorDescription:
      "Tu nuevo correo electrónico no debe coincidir con tu correo electrónico actual",
    exisitingAccountErrDescription: "El correo electrónico ya está en uso",
    reAuthenticateErrDescription:
      "Tiempo de sesión agotado. Por favor, verifica tu cuenta nuevamente",
    verifyNewEmailTitle: "Paso 2: Verifica Nuevo Correo Electrónico",
    verifyNewEmailDescription:
      "Se ha enviado un código de verificación a tu nuevo correo electrónico. El código es válido por 5 minutos.",
    verifyEmailCodePlaceHolder: "Ingresa tu código",
  },
});

export class ResetEmail extends Component {
  constructor(props) {
    super(props);
    // this.currentpasswordChange = this.currentpasswordChange.bind(this);
    this.changeEmail = this.changeEmail.bind(this);

    // this.updateEmailinFirebase = this.changeEmailinFirebase(this);
    // this.curPassword = this.curPassword.bind(this);

    // this.checkforDuplicateEmail = this.checkforDuplicateEmail.bind(this);

    this.newEmail = this.newEmail.bind(this);
    this.cfmEmail = this.cfmEmail.bind(this);

    this.verifyBtnStatus = this.verifyBtnStatus.bind(this);
    this.handleVerificationMessage = this.handleVerificationMessage.bind(this);
    this.handleErrorMessages = this.handleErrorMessages.bind(this);

    // this.verifyAcc = this.verifyAcc.bind(this);
    this.state = {
      emailOne: "",
      emailTwo: "",
      myName: "",
      myEmail: "",

      authenCode: "",

      superAdminID: "",
      oldEmail: "",
      userName: "",

      verifyPW: "",
      currentPW: "",
      verifyStatus: false,
      verificationMessage: "",
      emailState: "",
      clickedButton: false,

      verifyAgainStatus: false,
      // currentPassword: ""

      //NEW FOR VERIFICATION OF NEW EMAIL
      confirmEmailStatus: false,
      confirmEmailVerificationStatus: false,
      codeExpiryStatus: false,
      codeAuthentication: "",
    };
  }

  async componentWillMount() {
    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          var name = "";
          var email = "";

          snapshot.forEach((childSnapshot) => {
            if (childSnapshot.key === "name") {
              name = childSnapshot.val();
            } else if (childSnapshot.key === "email") {
              email = childSnapshot.val();
            }
          });
          this.setState({
            myName: name,
            myEmail: email,
          });
        }
      });

    //! GET LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    const db = fire.database();

    //retrieiving  the SuperAdmin UID
    await db
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminCode = superAdmin.key;

            db.ref("groupAccounts")
              .child(superAdminCode)
              .child("members")
              .once("value")
              .then((snapshot) => {
                snapshot.forEach((snapshot) => {
                  let memberVal = snapshot.val();
                  if (memberVal.memberEmail === auth.currentUser.email) {
                    this.setState({
                      superAdminID: superAdminCode,
                    });

                    //assign super admin uuid to SUPER_ADMIN_DETAILS.UUID in variables page
                    SUPER_ADMIN_DETAILS.UUID = superAdminCode;
                    customLog(
                      `the super admin uid is : ${SUPER_ADMIN_DETAILS.UUID}`
                    );
                  }
                });
              });
          });
        }
      });

    db.ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let emailData = snapshot.val().email;
        let nameData = snapshot.val().name;
        this.setState({
          oldEmail: emailData,
          userName: nameData,
        });
      });
  }

  getDeviceDetails = () => {
    let browser = "";
    let device = "";
    let version = "";
    if (reactDeviceDetect.isMobile) {
      device = reactDeviceDetect.mobileModel;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    } else if (reactDeviceDetect.isDesktop) {
      device = reactDeviceDetect.osName;
      browser = reactDeviceDetect.browserName;
      version = reactDeviceDetect.fullBrowserVersion;
    }

    return device + " using " + browser + ", version " + version;
  };

  verifyBtnStatus(placeHolder) {
    if (this.state.currentPW === "") {
      this.setState({
        verificationMessage: BLANK_ERR_MSG,
        verifyStatus: false,
      });
    } else {
      this.reAuthenticate(this.state.currentPW)
        .then(() => {
          // alert("Verification Successful!")
          this.setState({
            verifyStatus: true,
            verificationMessage: SUCCESS_MSG,
          });
        })
        .catch(() => {
          this.setState({
            verificationMessage: INCORRECT_ERR_MSG,
            verifyStatus: false,
          });
        });
    }
  }

  handleAuthenticationMessages(i) {
    if (i === CODE_DOES_NOT_MATCH) {
      return localizationStrings.verifyWrongCodeError;
    } else if (i === SESSION_TIMEOUT) {
      return localizationStrings.verifyCodeTimeOut;
    } else if (i === BLANK_ERR_MSG) {
      return localizationStrings.verifyPasswordBlank;
    } else if (i === null) {
      return "";
    }
  }

  handleVerificationMessage(msg) {
    if (msg === BLANK_ERR_MSG) {
      return localizationStrings.verifyPasswordBlank;
    } else if (msg === INCORRECT_ERR_MSG) {
      return localizationStrings.verifyPasswordErr;
    } else if (msg === SUCCESS_MSG) {
      return "";
    }
  }

  handleErrorMessages(msg) {
    if (msg === EMAILS_BLANK_ERR) {
      return localizationStrings.blankEmailErrorDescription;
    } else if (msg === EMAIL_SAME_ERR) {
      return localizationStrings.emailMatchCurrentErrorDescription;
    } else if (msg === EMAIL_INCORRECT_MATCH_ERR) {
      return localizationStrings.emailMatchErrorDescription;
    } else if (msg === EXISTING_ACC_ERR) {
      return localizationStrings.exisitingAccountErrDescription;
    } else if (msg === AUTHENTICATE_ACC_ERR) {
      return localizationStrings.reAuthenticateErrDescription;
    } else if (msg === EMAIL_ALREADY_EXISTS) {
      return localizationStrings.emailAlrExists;
    } else if (msg === EMAIL_SUCCESS) {
      return "";
    }
  }

  //TEMP saveActivityLogs (For testing)
  async saveActivityLogs(previousEmail, newemail) {
    let activityLogsDB = fire
      .database()
      .ref("individualActivities")
      .child(auth.currentUser.uid);
    let activityKey = activityLogsDB.push().key;

    let notifyLogsDB = fire
      .database()
      .ref("individualNotifications")
      .child(SUPER_ADMIN_DETAILS.UUID);
    let notifyKey = notifyLogsDB.push().key;
    //add to notification logs of SUPERADMIN only
    //get the username of the member

    if (auth.currentUser.uid !== SUPER_ADMIN_DETAILS.UUID) {
      DB.ref("groupAccounts")
        .child(SUPER_ADMIN_DETAILS.UUID)
        .child("members")
        .orderByChild("memberEmail")
        .equalTo(auth.currentUser.email)
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((snap) => {
            var memberName = snap.val().memberName;

            notifyLogsDB.child(notifyKey).set({
              notificationType: 4,
              description: "Email has been successfully updated",
              detailedDescription: "",
              platform: "Web App",
              isRead: false,
              snapKey: notifyKey,
              memberName: memberName,
              memberUid: auth.currentUser.uid,
              oldEmail: previousEmail,
              newEmail: newemail,
              timeStamp: Math.floor(new Date()),
            });
          });
        });
    }

    activityLogsDB.child(activityKey).set({
      activityType: 8,
      description: "Email has been updated",
      detailedDescription: "",
      // isRead: false,
      oldEmail: previousEmail,
      newEmail: newemail,
      userEmail: auth.currentUser.email,
      platform: "Web App",
      userUID: auth.currentUser.uid,
      snapKey: activityKey,
      timeStamp: Math.floor(new Date()),
    });
  }

  async onSubmit(email) {
    const randomCode = randomString.generate({
      //need to be initialized first
      length: 6,
    });

    //save verification code in database
    DB.ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .update({
        updateEmailVerification: {
          codeCreatedOn: Math.floor(new Date() / 1000),
          // codeCreatedOn: Math.floor(new Date()),
          verificationCode: randomCode,
        },
      })
      .then(() => {
        // const dataToSend = {
        //   userNewEmail: email,
        //   verificationCode: randomCode
        // }
        //  fetch(
        //   "https://us-central1-egeetouchindustrial.cloudfunctions.net/verifyUpdatedEmail",
        //   {
        //     method: "POST",
        //     body: JSON.stringify(dataToSend)
        //   }
        // )
        // console.log(`database successfully updted`)
      });
  }

  async verifyNewEmail(code) {
    let dataCode = "";
    let timestamp = "";
    let currentTime = Math.floor(new Date() / 1000);

    DB.ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .child("updateEmailVerification")
      .once("value")
      .then((snapshot) => {
        // console.log( `hi this is resiult: ${snapshot.val().verificationCode}`)

        dataCode = snapshot.val().verificationCode;
        timestamp = snapshot.val().codeCreatedOn;

        let difference = currentTime - timestamp;

        if (code === dataCode && difference < 300) {
          //600 in epoch = 10 minutes
          customLog("EMAIL SUCCESSFULLY AUTHENTICATED");
          this.setState({
            confirmEmailVerificationStatus: true,
            codeAuthentication: CODE_SUCCESS,
          });

          // } else if (this.state.codeExpiryStatus === false && code === dataCode && difference > 600 ) {
        } else if (code === "" && difference < 300) {
          this.setState({
            codeAuthentication: BLANK_ERR_MSG,
          });
        } else if (this.state.codeExpiryStatus === false && difference > 300) {
          customLog("SESSION EXPIRED");
          this.setState({
            codeExpiryStatus: true,
            codeAuthentication: SESSION_TIMEOUT,
          });

          //  console.log(`state after session has expired: ${this.state.codeExpiryStatus}`)
        } else if (code != dataCode && difference < 300) {
          customLog("CODE DOES NOT MATCH");
          this.setState({
            codeAuthentication: CODE_DOES_NOT_MATCH,
          });
        } else if (
          (this.state.codeExpiryStatus === true &&
            code === dataCode &&
            difference > 300) ||
          (this.state.codeExpiryStatus === true &&
            code != dataCode &&
            difference > 300) ||
          (this.state.codeExpiryStatus === true && difference > 300) ||
          (this.state.codeExpiryStatus === true &&
            code === "" &&
            difference > 300)
        ) {
          customLog(`RESENDING CODE`);

          this.checkForExistingAccount(this.state.emailOne);

          this.setState({
            codeExpiryStatus: false,
            codeAuthentication: "",
          });

          // console.log(`state after resending code: ${this.state.codeExpiryStatus}`)

          //resend new code
        } else {
        }
      });
  }

  async checkForExistingAccount(email) {
    DB.ref("registeredUsersOnPlatform")
      .orderByValue() //no need for forLoop
      .equalTo(email)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          this.setState({
            emailState: EMAIL_ALREADY_EXISTS,
          });
        } else {
          this.setState({
            confirmEmailStatus: true,
            emailState: EMAIL_SUCCESS,
          });

          const randomCode = randomString.generate({
            //need to be initialized first
            length: 6,
          });

          //save verification code in database
          DB.ref("registeredIndustrialUsersOnPlatform")
            .child(auth.currentUser.uid)
            .update({
              updateEmailVerification: {
                codeCreatedOn: Math.floor(new Date() / 1000),
                // codeCreatedOn: Math.floor(new Date()),
                verificationCode: randomCode,
              },
            });

          const dataToSend = {
            userNewEmail: email,
            verificationCode: randomCode,
            userName: this.state.userName,
          };

          fetch(
            "https://us-central1-egeetouchindustrial.cloudfunctions.net/verifyUpdatedEmail",
            {
              method: "POST",
              body: JSON.stringify(dataToSend),
            }
          );
        }
      });
  }

  async changeEmail() {
    await updateEmail(
      this.state.oldEmail,
      this.state.emailOne,
      SUPER_ADMIN_DETAILS.UUID,
      auth.currentUser.uid,
      auth.currentUser.email,
      this.state.userName,
      (callback) => {}
    );
  }

  async checkPassword(userPW) {
    if (userPW === "") {
      this.setState({
        verificationMessage: BLANK_ERR_MSG,
        verifyStatus: false,
      });
    } else {
      this.reAuthenticate(userPW)
        .then(() => {
          // alert("Verification Successful!")
          this.setState({
            verifyStatus: true,
            verificationMessage: SUCCESS_MSG,
          });

          this.changeEmail();
        })
        .catch(() => {
          this.setState({
            verificationMessage: INCORRECT_ERR_MSG,
            verifyStatus: false,
          });
        });
    }
  }

  curPassword(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("newemail").focus();
    }
  }

  newEmail(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("cfmemail").focus();
    }
  }

  cfmEmail(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("btnSearch").click();
    }
  }

  reAuthenticate = (passwordData) => {
    var user = auth.currentUser;
    var cred = firebase.auth.EmailAuthProvider.credential(
      user.email,
      passwordData
    );
    return user.reauthenticateWithCredential(cred);
  };
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    return (
      <div
        style={{ maxWidth: "500px", marginRight: "auto", marginLeft: "auto" }}
      >
        {/* <br /> */}
        {/* <br /> */}
        <Form>
          <FormGroup>
            <table className={"accManagementTable"}>
              <tbody>
                <tr>
                  <td>
                    <div className="verifyFieldInput">
                      <h4>{localizationStrings.updateEmailTitle}</h4>
                      {this.state.confirmEmailStatus === false ? null : (
                        <img
                          style={{ height: "25px" }}
                          src={verifyCheck}
                          alt="verifyCheck"
                        />
                      )}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>{localizationStrings.currentEmailTitle}</p>
                    <FormControl
                      type="email"
                      id="currEmail"
                      className="passwordInput"
                      defaultValue={auth.currentUser.email}
                      // title={auth.currentUser.email}
                      disabled={true}
                      // onKeyUp={this.curPassword}
                    />
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <ControlLabel
                      style={{
                        whiteSpace: "nowrap",
                        width: "60%",
                        fontSize: "18px"
                      }}
                    >
                      {localizationStrings.newPasswordTitle}:
                    </ControlLabel>
                  </td> */}
                  <td>
                    <FormControl
                      type="email"
                      id="newemail"
                      name="newemail"
                      className="passwordInput"
                      placeholder={localizationStrings.newEmailTitle}
                      onChange={(event) =>
                        this.setState({ emailOne: event.target.value })
                      }
                      onKeyUp={this.newEmail}
                      disabled={
                        this.state.confirmEmailStatus === false ? false : true
                      }
                      //  disabled={ this.state.verifyStatus === false ? true : false}
                    />
                  </td>
                </tr>
                <tr>
                  {/* <td>
                    <ControlLabel
                      style={{
                        whiteSpace: "nowrap",
                        width: "60%",
                        fontSize: "18px"
                      }}
                    >
                      {localizationStrings.confirmNewPasswordTitle}:
                    </ControlLabel>
                  </td> */}
                  <td>
                    <FormControl
                      type="email"
                      id="cfmemail"
                      name="cfmemail"
                      className="passwordInput"
                      placeholder={localizationStrings.confirmNewEmailTitle}
                      onChange={(event) =>
                        this.setState({ emailTwo: event.target.value })
                      }
                      onKeyUp={this.cfmEmail}
                      disabled={
                        this.state.confirmEmailStatus === false ? false : true
                      }
                      //  disabled={ this.state.verifyStatus === false ? true : false}
                    />
                    {this.state.emailState === EMAIL_SUCCESS ? null : (
                      <p className="verifyErrMsg">
                        {this.handleErrorMessages(this.state.emailState)}
                      </p>
                    )}
                  </td>
                </tr>

                <tr>
                  <td>
                    <Button
                      id="btnSearch"
                      className="loginsignupbutton"
                      onClick={() => {
                        if (this.state.emailOne !== this.state.emailTwo) {
                          // alert(localizationStrings.confirmEmailAlert);
                          this.setState({
                            emailState: EMAIL_INCORRECT_MATCH_ERR,
                          });
                        } else if (
                          this.state.emailOne === "" &&
                          this.state.emailTwo === ""
                        ) {
                          // alert(localizationStrings.enterEmailsAlert);
                          this.setState({
                            emailState: EMAILS_BLANK_ERR,
                          });
                        } else if (
                          this.state.emailOne === auth.currentUser.email
                        ) {
                          this.setState({
                            emailState: EMAIL_SAME_ERR,
                          });
                        } else {
                          this.checkForExistingAccount(this.state.emailOne);
                          // this.checkForDuplicateEmail(this.state.emailOne);
                          // this.changeEmail();
                        }
                      }}
                      // disabled={ this.state.verifyStatus === false && this.state.clickedButton === false ? true
                      //             : this.state.verifyStatus === true && this.state.clickedButton === true ? true
                      //             : false}

                      disabled={
                        this.state.confirmEmailStatus === false ? false : true
                      }
                    >
                      {localizationStrings.confirmButton}
                    </Button>
                  </td>
                </tr>
                {/* <tr>
                  <td>
                    <Button 
                    className={"clearSendBtn"}
                    onClick = {() => {
                      this.onSubmit(this.state.emailOne);
                    }}
                    // disabled={ this.state.clickedButton === true ? true : false}
                    >
                      {localizationStrings.clearAllButton}
                    </Button>
                  </td>
                </tr> */}

                {this.state.confirmEmailStatus === false ? null : (
                  <tr>
                    <td>
                      <div className="verifyFieldInput">
                        <h4>{localizationStrings.verifyNewEmailTitle}</h4>
                        {this.state.confirmEmailVerificationStatus ===
                        false ? null : (
                          <img
                            style={{ height: "25px" }}
                            src={verifyCheck}
                            alt="verifyCheck"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                )}
                {this.state.confirmEmailStatus === false ? null : (
                  <tr>
                    <td>
                      <p>{localizationStrings.verifyNewEmailDescription}</p>
                      <FormControl
                        // type="number"
                        id="veriCode"
                        name="veriCode"
                        maxLength="6"
                        onChange={(event) => {
                          this.setState({ authenCode: event.target.value });
                        }}
                        className="verificationCodeInput"
                        placeholder={
                          localizationStrings.verifyEmailCodePlaceHolder
                        }
                        disabled={
                          this.state.confirmEmailVerificationStatus === true
                            ? true
                            : false
                        }
                        // onKeyUp={this.curPassword}
                      />
                      {this.state.codeAuthentication === CODE_SUCCESS ? null : (
                        <p className="verifyErrMsg">
                          {this.handleAuthenticationMessages(
                            this.state.codeAuthentication
                          )}
                        </p>
                      )}
                    </td>
                  </tr>
                )}

                {this.state.confirmEmailStatus === false ? null : (
                  <tr>
                    <td>
                      <Button
                        className={"loginsignupbutton"}
                        id="verEmBtn"
                        onClick={() => {
                          // if(this.state.authenCode === "") {

                          //   this.setState ({
                          //     codeAuthentication: BLANK_ERR_MSG
                          //   })
                          // } else {
                          this.verifyNewEmail(this.state.authenCode);
                          // }
                        }}
                        disabled={
                          this.state.confirmEmailVerificationStatus === true
                            ? true
                            : false
                        }
                      >
                        {this.state.codeExpiryStatus === false
                          ? "Verify Email"
                          : "Resend Code"}
                        {/* Verify Email */}
                      </Button>
                    </td>
                  </tr>
                )}

                {this.state.confirmEmailVerificationStatus === false ? null : (
                  <tr>
                    <td>
                      <div className="verifyFieldInput">
                        <h4>{localizationStrings.verifyPWTitle}</h4>
                        {this.state.verifyStatus === false ? null : (
                          <img
                            style={{ height: "25px" }}
                            src={verifyCheck}
                            alt="verifyCheck"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {this.state.confirmEmailVerificationStatus === false ? null : (
                  <tr>
                    <td>
                      <FormControl
                        id="verifyPW"
                        name="verifyPW"
                        type="password"
                        className="passwordInput"
                        placeholder={localizationStrings.verifyPasswordInput}
                        disabled={
                          this.state.verifyStatus === true ? true : false
                        }
                        onChange={(event) => {
                          this.setState({ currentPW: event.target.value });
                        }}
                      />
                      {this.state.verificationMessage === SUCCESS_MSG ? null : (
                        <p className="verifyErrMsg">
                          {this.handleVerificationMessage(
                            this.state.verificationMessage
                          )}
                        </p>
                      )}
                    </td>
                  </tr>
                )}

                {this.state.confirmEmailVerificationStatus === false ? null : (
                  <tr>
                    <td>
                      <Button
                        disabled={
                          this.state.verifyStatus === false ? false : true
                        }
                        className={"verifyPWBtn"}
                        onClick={() => {
                          if (this.state.currentPW === "") {
                            this.setState({
                              verificationMessage: BLANK_ERR_MSG,
                            });
                          } else {
                            // this.verifyBtnStatus(this.state.currentPW);
                            this.checkPassword(this.state.currentPW);
                          }
                        }}
                      >
                        {localizationStrings.verifyBtn}
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>Current Password:</ControlLabel>
                                <FormControl type="password" id="currentpassword" name="currentpassword"
                                    onChange={event => this.setState({ currentPassword: event.target.value })} 
                                    onKeyUp={this.curPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>New Password:</ControlLabel>
                                <FormControl type="password" id="newpassword" name="newpassword"
                                    onChange={event => this.setState({ passwordOne: event.target.value })}
                                    onKeyUp={this.newPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <ControlLabel style={{ whiteSpace: "nowrap", width: "60%", fontSize: "18px" }}>Confirm New Password:</ControlLabel>
                                <FormControl type="password" id="cfmpassword" name="cfmpassword"
                                    onChange={event => this.setState({ passwordTwo: event.target.value })}
                                    onKeyUp={this.cfmPassword}/>
                            </div><br />
                            <div style={{ display: "flex" }}>
                                <div style={{ width: "50%", marginTop: "20px", marginLeft: "5px" }}>
                                    <Button
                                        id="btnSearch"
                                        className="btn btn-primary btn-fill"
                                        style={{ width: "100%" }}
                                        onClick={() => {
                                            if (this.state.passwordOne !== this.state.passwordTwo) {
                                                alert('New Password and Confirm New Password do not match!')
                                            }else if(this.state.passwordOne === "" && this.state.passwordTwo === ""){
                                                alert("Please enter your New Password and Confirm New Password!")
                                            } 
                                            else {
                                                this.changePW(this.state.passwordOne)
                                            }
                                        }}
                                    >
                                        Confirm <small>確かめます</small>
                                    </Button>
                                </div>
                                <Button style={{ width: "50%", marginTop: "20px", marginLeft: "5px" }}
                                    type="reset"
                                >
                                    Clear All <small>クリア</small>
                                </Button>
                            </div> */}
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default ResetEmail;
